import {
    faChartLine, faCreditCard, faFileInvoiceDollar, faLayerGroup, faMoneyBillWave,
    faUndo, faBalanceScale, faReceipt, faListAlt,
} from '@fortawesome/free-solid-svg-icons';

export const FINANCE_NAV = [
    { to: '/finance', label: 'Revenue Overview', icon: faChartLine, end: true },
    { to: '/finance/payments', label: 'Payment Processing', icon: faCreditCard },
    { to: '/finance/invoicing', label: 'Invoicing & Dunning', icon: faFileInvoiceDollar },
    { to: '/finance/subscriptions', label: 'Subscriptions & Plans', icon: faLayerGroup },
    { to: '/finance/payouts', label: 'Payouts & Settlement', icon: faMoneyBillWave },
    { to: '/finance/refunds', label: 'Refunds & Disputes', icon: faUndo },
    { to: '/finance/reconciliation', label: 'Reconciliation', icon: faBalanceScale },
    { to: '/finance/tax', label: 'Tax & Regulatory', icon: faReceipt },
    { to: '/finance/audit', label: 'Financial Audit Trail', icon: faListAlt },
];
